import { render, staticRenderFns } from "./Hero404.vue?vue&type=template&id=021ebc6b&"
import script from "./Hero404.vue?vue&type=script&lang=js&"
export * from "./Hero404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports